var map = {
	"./icon-add-file.svg": "c3fa",
	"./icon-bag-with-bg.svg": "0194",
	"./icon-basic-droid.svg": "ccdf",
	"./icon-bell.svg": "7744",
	"./icon-clear.svg": "cff0",
	"./icon-close.svg": "3324",
	"./icon-drag-points.svg": "d693",
	"./icon-dron-flying.svg": "3b50",
	"./icon-embed-btn-close.svg": "406a",
	"./icon-embed-btn-thumb-up.svg": "e6677",
	"./icon-feature-auto-redirect.svg": "1093",
	"./icon-feature-company-logo.svg": "f8c1",
	"./icon-feature-cta.svg": "311e2",
	"./icon-feature-custom-domain.svg": "2730",
	"./icon-feature-export.svg": "2125",
	"./icon-feature-responses.svg": "8236",
	"./icon-feature-thank-you.svg": "b6ac",
	"./icon-feature-unlimited.svg": "93b4",
	"./icon-feature-webhook.svg": "eab4",
	"./icon-feature-white-label.svg": "7e17",
	"./icon-flag-with-bg.svg": "efa2",
	"./icon-free-plan.svg": "6acd",
	"./icon-g2-badge.svg": "5ac5",
	"./icon-google-sheets.svg": "566d",
	"./icon-infinite.svg": "cf05",
	"./icon-main-logo-light.svg": "7a70",
	"./icon-main-logo.svg": "e93d",
	"./icon-newspaper.svg": "cdcc",
	"./icon-pabbly.svg": "07a9a",
	"./icon-page-not-found.svg": "7bb1",
	"./icon-pen.svg": "33e5",
	"./icon-ph-badge.svg": "cee0",
	"./icon-preview-unknown.svg": "ce3c",
	"./icon-qr-ghost.svg": "278e",
	"./icon-question-last-comment.svg": "e11d",
	"./icon-question-multiple.svg": "ca94",
	"./icon-question-nps-horizontal.svg": "67474",
	"./icon-question-nps-vertical.svg": "c8a2",
	"./icon-question-open-email.svg": "e329",
	"./icon-question-open-multi-line.svg": "847d",
	"./icon-question-open-number.svg": "a110",
	"./icon-question-open-phone.svg": "6719",
	"./icon-question-open-single-line.svg": "52bf",
	"./icon-question-smiles-color.svg": "a504",
	"./icon-question-smiles-gray.svg": "c415",
	"./icon-question-stars.svg": "92a9",
	"./icon-question-swipe-image.svg": "2c1c",
	"./icon-question-swipe-text.svg": "48fa",
	"./icon-smiles-with-bg.svg": "fe6b",
	"./icon-survey-hint.svg": "203c",
	"./icon-survey-messages.svg": "fada",
	"./icon-survey-nav.svg": "4ed7",
	"./icon-survey-password.svg": "5fa0",
	"./icon-survey-subtype-cta.svg": "230d",
	"./icon-survey-subtype-inline.svg": "e122",
	"./icon-survey-subtype-side-button.svg": "a542",
	"./icon-survey-type-fullpage.svg": "4122",
	"./icon-survey-type-link.svg": "d8b2",
	"./icon-survey-type-popup.svg": "b40a",
	"./icon-survey-type-widget.svg": "ed9e",
	"./icon-thankyou-screen.svg": "fb0c",
	"./icon-tooltip-comment-button-skip.svg": "da3d",
	"./icon-tooltip-comment-button-submit.svg": "d484",
	"./icon-tooltip-question-multiple-button.svg": "103d",
	"./icon-tooltip-question-multiple-required.svg": "5629",
	"./icon-tooltip-question-nps-desc.svg": "16e6",
	"./icon-tooltip-question-nps-max.svg": "92d2",
	"./icon-tooltip-question-nps-min.svg": "0628",
	"./icon-tooltip-question-open-button.svg": "74d0",
	"./icon-tooltip-question-open-desc.svg": "1671",
	"./icon-tooltip-question-open-email-error.svg": "c8f7",
	"./icon-tooltip-question-open-error.svg": "9cb6",
	"./icon-tooltip-question-open-number-error.svg": "6813",
	"./icon-tooltip-question-open-phone-error.svg": "e988",
	"./icon-tooltip-question-smiles-max.svg": "8957",
	"./icon-tooltip-question-smiles-min.svg": "4dcc",
	"./icon-tooltip-question-stars-max.svg": "abac",
	"./icon-tooltip-question-stars-min.svg": "c61b",
	"./icon-tooltip-question-swipe-desc.svg": "784c",
	"./icon-tooltip-question-swipe-left-button.svg": "6757",
	"./icon-tooltip-question-swipe-right-button.svg": "9adc",
	"./icon-tooltip-question-swipe-selected.svg": "3f1c",
	"./icon-tooltip-survey-hint-tooltip.svg": "ef07",
	"./icon-tooltip-survey-messages-paused-desc.svg": "3895",
	"./icon-tooltip-survey-messages-paused-title.svg": "98f4",
	"./icon-tooltip-survey-messages-taken-desc.svg": "6d7d",
	"./icon-tooltip-survey-messages-taken-title.svg": "50df",
	"./icon-tooltip-survey-nav-back.svg": "4a57",
	"./icon-tooltip-survey-nav-finish.svg": "a131",
	"./icon-tooltip-survey-nav-restart.svg": "3525",
	"./icon-tooltip-survey-password-button.svg": "ea5c",
	"./icon-tooltip-survey-password-error.svg": "d413",
	"./icon-tooltip-survey-password-placeholder.svg": "095f",
	"./icon-tooltip-survey-password-title.svg": "0b11",
	"./icon-tooltip-welcome-button.svg": "681f",
	"./icon-tooltip-welcome-swipe-desc.svg": "06ac",
	"./icon-top-droid.svg": "6a4b",
	"./icon-translation.svg": "b04c",
	"./icon-webhooks.svg": "c002",
	"./icon-welcome-screen.svg": "d5d6",
	"./icon-wind.svg": "10e6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0057";